import { produce } from 'immer';
import { createStore } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
var defaultInitState = {
    data: {},
};
export var createDataStore = function (initState) {
    if (initState === void 0) { initState = defaultInitState; }
    return createStore()(subscribeWithSelector(function (set) { return ({
        data: initState.data,
        setInitData: function (data) {
            return set({ data: data });
        },
        setNestedValue: function (path, value) {
            // using immer to update deeply nested object
            // https://zustand.docs.pmnd.rs/guides/updating-state#deeply-nested-object
            return set(produce(function (state) { return updateNestedValue(state, path, value); }));
        },
    }); }));
};
// using generic path-like to avoid 'invalid left-hand side in assignment'
export var updateNestedValue = function (state, path, value) {
    var keys = path.split('.');
    var obj = state;
    for (var i = 0; i < keys.length - 1; i++) {
        var prop = keys[i];
        if (!obj[prop])
            obj[prop] = {};
        obj = obj[prop];
    }
    obj[keys[keys.length - 1]] = value;
};
//# sourceMappingURL=data-store.js.map